import { createRoot } from "react-dom/client"

import App from "./App"
import "./main.css"
import { setupSentry } from "./sentry"

setupSentry()
createRoot(document.getElementById("root")!).render(<App />)
